import CustomModal from '../../modals';
import ImageClass from '../../../assets';
import { RootState } from '../../../redux/store';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';

/**
 * @heading1: AddPipelineModal
 * @paragraph: A modal component for adding a new pipeline. Uses Formik for form handling
 * and integrates with Redux for pipeline creation.
 * @param: {boolean} open - Whether the modal is open or not.
 * @param: {function} onClose - Function to close the modal.
 */

const ConnectFacebookModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * initialValues: {PipelineParams} -  Initial form values for the pipeline creation form.
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders: An object containing the loader details from the Redux store.
     */
    // Initial form values for the pipeline creation form
    const { id } = useParams();
    const { token } = useSelector((state: RootState) => state.app);

    /**
     * @heading3: Functions
     * @heading4: Handles the form submission by dispatching a Redux thunk.
     * @param: {PipelineParams} values - The form values for creating a pipeline.
     */
    const handleSubmit = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_URL}auth/facebook/${token}/${id ? id as string : 0}`;
    };

    return <CustomModal open={open} handleClose={onClose} title="Connecting your Facebook Leads">
        <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={1}>
                <img src={ImageClass.facebookLogo} height={50} width={50} alt="facebook" />
                <Typography variant="subtitle2" fontWeight="bold" align="center">Facebook Business</Typography>
            </Box>
            <Typography variant="subtitle2" gutterBottom>
                By granting Gonzy access to your Facebook Business, Gonzy will be able to retrieve lead data from your Meta marketing campaigns.
            </Typography>
            <Typography variant="subtitle2">
                This means that Gonzy will have access to some information about your clients, like the email addresses and phone numbers that you collect.
                We&apos;ll only use that access to power your Gonzy Facebook Leads integration and make life easier for you, never for any nefarious purposes
                of our own. It&apos;s your data. We just want to help you use it better.
            </Typography>
            <Box display="flex" justifyContent="center">
                <Button variant="contained" onClick={handleSubmit}>Continue</Button>
            </Box>
        </Box>
    </CustomModal>;
};

export default ConnectFacebookModal;